module.exports = __webpack_public_path__ + "img/no_events_available.5db30f7b.png";